/* eslint-disable max-len */
import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function Divider({ color, className }) {
  return (
    <Row className={className}>
      <Col xs={1} sm={2}>&nbsp;</Col>
      <Col xs={10} sm={8}><hr className={`hr-${color || 'default'}`} /></Col>
      <Col xs={1} sm={2}>&nbsp;</Col>
    </Row>
  );
}
